<div *ngIf="isOpen" class="modal fade show d-block"  tabindex="-1">
  <div class="modal-dialog modal-{{size}}" [ngClass]="optionalClasses">
    <div class="modal-content">
        <ng-content></ng-content>
    </div>
  </div>
</div>
